import axios from 'axios';

import config from 'core/config';

const cancellable = (handler) => {
  const source = axios.CancelToken.source();
  const resultPromise = handler(source.token).then((x) => x.data);

  resultPromise.cancel = () => source.cancel();

  return resultPromise;
};

const http = axios.create({
  baseURL: config.api.url,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: config.api.timeout
});

let bearerToken = null;

http.interceptors.request.use((config) => {
  if (bearerToken) {
    config.headers['Authorization'] = `Bearer ${bearerToken}`;
  }

  return config;
});

const isApiError = (error, statusCode) => axios.isAxiosError(error) && error.response?.status === statusCode;

export const isNotFoundError = (error) => isApiError(error, 404);

export const isForbiddenError = (error) => isApiError(error, 403);

export const isServerError = (error) =>
  axios.isAxiosError(error) && error.response?.status != null && error.response.status >= 500;

const apiClient = {
  get: (url, config = {}) => cancellable((cancelToken) => http.get(url, { ...config, cancelToken })),

  post: (url, data, config = {}) => cancellable((cancelToken) => http.post(url, data, { ...config, cancelToken })),

  put: (url, data, config = {}) => cancellable((cancelToken) => http.put(url, data, { ...config, cancelToken })),

  delete: (url, config = {}) => cancellable((cancelToken) => http.delete(url, { ...config, cancelToken })),

  setBearerToken: (token) => {
    bearerToken = token;
  }
};

export default apiClient;
